import React, { PropTypes, Component } from "react"
import { disposeFilename } from "app/vendor/util"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import "./flexableFileName.scss"
import { Row } from "antd"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { getCurrentApp } from "app/api/localTools"

export default class Index extends Component {
  render() {
    const { filename, className, children, highlight = true, keywords, matched } = this.props
    const { front, end } = disposeFilename(filename)
    const highlightShowed = highlight && highlightable(filename, keywords)
    return (
      <MaterialTip
        overlayClassName="ellipsis-tip"
        title={filename}>
        <Row className={className + " filename-wrapper filename"} type="flex">
          <div className="ellipsis filename-front">
            {
              highlightShowed
              ? (
                <Highlighter 
                   highlightClassName="lightlight"
                   highlightStyle={{ fontWeight: "normal" }}
                   searchWords={[front]}
                   textToHighlight={front}
                 />
              )
              : (
                <span style={{color: (getCurrentApp() === 'pgd' && !matched) ? 'red' : 'unset'}}>{front}</span>
              )
            }
          </div>
          <div className="filename-end">
            {
              highlightShowed
              ? (
                <Highlighter
                   highlightClassName="lightlight"
                   highlightStyle={{ fontWeight: "normal" }}
                   searchWords={[end]}
                   textToHighlight={end}
                 />
              )
              : (
               <span style={{color: (getCurrentApp() === 'pgd' && !matched) ? 'red' : 'unset'}}>{end}</span>
              )
            }
          </div>
          {children}
        </Row>
      </MaterialTip>
    )
  }
}

Index.propTypes = {
  filename: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/app/components/normal/FlexableFileName/index.js